import { render, staticRenderFns } from "./index.vue?vue&type=template&id=791fa46e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('791fa46e')) {
      api.createRecord('791fa46e', component.options)
    } else {
      api.reload('791fa46e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=791fa46e&", function () {
      api.rerender('791fa46e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captain_bonuses/logs/index.vue"
export default component.exports